import { Controller } from 'react-hook-form';
import { Select, InputText, Autocomplete } from '@ui/src';
import { CardPaymentSystem } from '../../../hoc/common/cards/types';

import { CardOrderTypes } from './types';

import cn from './styles.module.css';

const CardItemOrderForm = ({
  control,
  errors,
  physical,
  countries,
  setValue,
}: CardOrderTypes) => (
  <form className={cn.orderCardForm}>
    <div className={cn.orderCardFormTitle}>Order details</div>
    <div className={cn.orderCardFormGroup}>
      <Controller
        control={control}
        name="paymentSystem"
        render={({ field: { onChange, value } }) => (
          <Select
            list={[
              { name: 'Visa', value: CardPaymentSystem.VISA },
              { name: 'MasterCard', value: CardPaymentSystem.MASTER_CARD },
              { name: 'UnionPay', value: CardPaymentSystem.UNION_PAY },
            ]}
            placeholder="Choose payment system"
            name="userId"
            value={value}
            onChange={onChange}
            title="Payment system"
            error={errors?.paymentSystem?.message}
          />
        )}
      />
    </div>
    <div className={cn.orderCardFormGroup}>
      <Controller
        control={control}
        name="cardType"
        render={({ field: { onChange, value } }) => (
          <Select
            list={[
              { name: 'Physical', value: 'physical' },
              { name: 'Virtual', value: 'virtual' },
            ]}
            placeholder="Choose payment system"
            name="userId"
            value={value}
            onChange={(e) => {
              onChange(e);

              setValue('physical', Boolean(e.target.value === 'physical'));
            }}
            title="Card type"
            error={errors?.cardType?.message}
          />
        )}
      />
    </div>
    {physical && (
      <>
        <div className={cn.orderCardFormTitle}>Address details</div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="countryId"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                list={countries}
                placeholder="Choose country"
                name="countryId"
                value={value}
                onChange={(e) => {
                  onChange(e);

                  const currentCountry = countries?.find(
                    (item) => item.value === e.target.value,
                  );

                  setValue('countryName', currentCountry?.name);
                }}
                title="Country"
                error={errors?.paymentSystem?.message}
              />
            )}
          />
          <Controller
            control={control}
            name="countryName"
            render={({ field: { value } }) => (
              <input type="hidden" name="countryName" value={value} />
            )}
          />
        </div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="city"
            render={({ field: { onChange, value } }) => (
              <InputText
                name="city"
                placeholder="Enter City"
                onChange={onChange}
                value={value}
                title="City"
                error={errors?.city?.message}
              />
            )}
          />
        </div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="street"
            render={({ field: { onChange, value } }) => (
              <InputText
                name="street"
                placeholder="Enter street"
                onChange={onChange}
                value={value}
                title="Street"
                error={errors?.street?.message}
              />
            )}
          />
        </div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="apartment"
            render={({ field: { onChange, value } }) => (
              <InputText
                name="apartment"
                placeholder="Enter apartment"
                onChange={onChange}
                value={value}
                title="Apartment"
                error={errors?.apartment?.message}
              />
            )}
          />
        </div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="postCode"
            render={({ field: { onChange, value } }) => (
              <InputText
                name="postCode"
                placeholder="Enter Post code"
                onChange={onChange}
                value={value}
                title="Post code"
                error={errors?.postCode?.message}
              />
            )}
          />
        </div>
      </>
    )}
  </form>
);

export default CardItemOrderForm;
